let Table = mc.widgets.Table;

class SubjectResponses extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      questions: []
    };
  }

  componentDidMount() {
    let annotation = this.props.annotation;
    let url = `/studies/${annotation.studyId}/annotations/${annotation.id}/questions`;

    mc.ajax.get(url).then((function (response) {
      let questions = mc.ajax.parse(response).items;

      this.setState({ questions });
    }).bind(this));
  }

  render() {
    let annotation = this.props.annotation;
    let questions = this.state.questions;

    let cols = [
      {
        prop: "question",
        label: tx("question"),
        width: "65%",
        sort: false
      },
      {
        prop: "answer",
        label: tx("answer"),
        width: "35%",
        sort: false
      }
    ];

    return (
      <div>
        <h1>{annotation.event.displayName}</h1>
        <Table data={questions} cols={cols}/>
      </div>
    );
  }
}

module.exports = SubjectResponses;